import * as React from 'react';
import { ReportInstitutionUserView } from 'cb-model';
import {
  PageTitle,
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useCloneEntity,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';
import { ReportMenu } from './ReportMenu';
import { Filter } from 'gossamer-unified';
import { useSetMaxWeekCommencing } from './useSetMaxWeekCommencing';

export const UserWeekSearch = (): React.JSX.Element => {
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(ReportInstitutionUserView);
  useSetMaxWeekCommencing(queryOptions, setQueryOptions);
  const LocalReportInstitutionUserView = useCloneEntity(ReportInstitutionUserView, (clone) => {
    clone.fields.user_id.listColumn = true;
  });
  const gCacheQueryItem = useCacheQuery(ReportInstitutionUserView, queryOptions);
  LocalReportInstitutionUserView.fields.institution_id.listColumn = !queryOptions?.where?.and?.find(
    (filt: Filter) => filt.fieldId === 'institution_id' && !!filt.value,
  );
  LocalReportInstitutionUserView.fields.week_commencing.listColumn = !queryOptions?.where?.and?.find(
    (filt: Filter) => filt.fieldId === 'week_commencing' && !!filt.value,
  );

  return (
    <>
      <PageTitle title="User / Week Report" />
      <ReportMenu />
      <Section>
        <p>Bookings and Attendance per User per Week</p>
        <PaginatorAndListSettings
          entity={LocalReportInstitutionUserView}
          gCacheQuery={gCacheQueryItem}
          queryOptions={queryOptions}
          render={Search}
          setQueryOptions={setQueryOptions}
        />
      </Section>
    </>
  );
};
